module.exports = __webpack_public_path__ + "img/icon_menu1.27f05eca.jpg";